import article_icon from '../article-icon.svg';
import video_icon from '../video-icon.svg';
import important_documents_illustration_big from './important-documents-illustration-big.svg';
import life_at_innogy_illustration_big from './life-at-innogy-illustration-big.svg';
import calendar from './calendar.svg';

const assets = {
    content_units: {
        important_documents: {
            illustration_big: important_documents_illustration_big
        },
        life_at_innogy: {
            illustration_big: life_at_innogy_illustration_big
        },
        article_icon: article_icon,
        video_icon: video_icon
    },
    dashboard: {
        calendar
    }
};

export default assets;
